import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyBjEjC9a4TNtCU7BEJ1VCS3HgytoHLAPeM",
  authDomain: "umechan-project.firebaseapp.com",
  projectId: "umechan-project",
  storageBucket: "umechan-project.firebasestorage.app",
  messagingSenderId: "1050114322809",
  appId: "1:1050114322809:web:590efe33aec794abcebfa8",
  measurementId: "G-R1TD93YPRL"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
